import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { setCurrentItem } from '../../actions/currentItem';
import { fetchRelatedSnapshotFeed } from '../../actions/relatedSnapshots';
import './styles.scss';

class PostersGrid extends React.Component {

  constructor(props) {
    super(props);
    this.setCurrentItem = this.setCurrentItem.bind(this);
  }

  setCurrentItem(id, state, e) {
    e.preventDefault();
    const $this = $(e.target).closest('a');
    if ($this.find('[data-headline]').hasClass('active')) {
      return;
    }
    this.props.dispatch(fetchRelatedSnapshotFeed(id, true));
    this.props.dispatch(setCurrentItem(id, state));
    this.context.router.push($this.attr('href'));
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos);
  }

  render() {
    const { camGroups, currentItemId } = this.props;
    const currentItem = this.setCurrentItem;
    const sortedCamGroups = camGroups.slice(0).sort((a, b) => a.title.localeCompare(b.title));
    const uniqueCamGroups = this.removeDuplicates(sortedCamGroups, 'title');

    // Move 'all-live-cams' poster to the first item
    const allLiveCamsObject = uniqueCamGroups.filter((v) => { // Get the object in the uniqueCamGroups array
      return v.slug === 'explore-all-cams'; // Hardcoded slug
    })[0];
    const allLiveCamsIndex = uniqueCamGroups.indexOf(allLiveCamsObject);
    if (allLiveCamsIndex > -1) {
      uniqueCamGroups.splice(allLiveCamsIndex, 1);     // remove allLiveCamsObject from uniqueCamGroups
      uniqueCamGroups.splice(0, 0, allLiveCamsObject); // insert allLiveCamsObject in first position
    }

    // Move 'currently-live' poster to the first item
    const currentlyLive = uniqueCamGroups.filter((v) => { // Get the object in the uniqueCamGroups array
      return v.slug === 'currently-live'; // Hardcoded slug
    })[0];
    const currentlyLiveIndex = uniqueCamGroups.indexOf(currentlyLive);
    if (currentlyLiveIndex > -1) {
      uniqueCamGroups.splice(currentlyLiveIndex, 1); // remove currentlyLive from uniqueCamGroups
      uniqueCamGroups.splice(0, 0, currentlyLive); // insert currentlyLive in first position
    }

    return (
      <div>
        <div className="posters-title d-flex align-items-center justify-content-center">
          <div
            className="text-uppercase u-textSize-18 pr-10 panel-title d-inline-block">
            Pearls of the Planet
          </div>
          <div
            className="panel-label u-font-foundation-light u-textSize-18 pl-10 pr-55 d-inline-block">
            The Explore Livecam Library
          </div>
        </div>
        <div>
          <div className="p-10 d-flex flex-wrap justify-content align-items-center no-gutters">
            {uniqueCamGroups.map((camgroup, index) => {
              if (camgroup.feed_count && camgroup.feed_count > 0) {
                if (camgroup.user) return null;
                const uniqueKey = `${camgroup.id}-${index}`;
                const isActive = (camgroup.id === currentItemId) ? 'active' : '';
                const displayText = (camgroup.id === currentItemId) ? 'Now Watching Group' : 'Watch LiveCam Group';
                const camgroupUrl = `/livecams/${camgroup.slug}/${camgroup.feeds[0].slug}`;

                return (
                  <Link
                    to={camgroupUrl}
                    key={uniqueKey}
                    className="cam-group-item poster-item"
                    onClick={e => currentItem(camgroup.id, camGroups, e)}
                    data-cam-group-id={camgroup.id}
                    data-channel-id={camgroup.channel.id}
                  >
                    <div className="cam-group-item-wrapper">
                      <img src={camgroup.poster_url.replace('http://', 'https://')} height="240" />
                      <div className="cam-item-overlay">
                        <div data-headline="" className={`${isActive} align-items-center`}>
                          <div>
                            <div className="u-font-foundation-roman u-textSize-18">{displayText}</div>
                            <div className="live-cam-label-separator" />
                            <div className="u-font-foundation-light u-textSize-18">{ camgroup.feed_count }<br /> livecams</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    camGroups: state.cam_groups.data || [],
    currentItemId: state.currentItem.data.cam_group.id,
  };
};

PostersGrid.propTypes = {
  camGroups: PropTypes.array,
  currentItemId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
};

PostersGrid.defaultProps = {
  camGroups: [
    {
      poster_url: 'https://explore.org/images/6945/151/228/y/african-wildlife.jpg',
      feed_count: 12,
      title: 'African Wildlife',
    },
  ],
};

PostersGrid.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(PostersGrid);
